// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "chunk." + {"48":"1822f4882d7dac6e597b","60":"74b344a92167945ac57c","232":"59e9db8e67623039a868","303":"35a077f4fad62d4dad0c","801":"9d02fd36b440fa4cca80","802":"a5c3fd6e1988026eb6c0"}[chunkId] + ".js";
};